import { Loader2 } from "lucide-react";
import { Label } from "@/components/ui/label";

export const Logo = ({ className = "", light = false }) => (
  <span className={`inline-flex items-center gap-2 font-display font-extrabold text-xl tracking-tight ${className}`} data-testid="triply-logo">
    <svg width="30" height="30" viewBox="0 0 32 32" aria-hidden="true">
      <circle cx="11" cy="13" r="8" fill="#F97316" />
      <circle cx="21" cy="13" r="8" fill="#0D9488" opacity="0.9" />
      <circle cx="16" cy="21" r="8" fill="#F59E0B" opacity="0.9" />
      <path d="M9 22 L16 9 L23 22" stroke="#fff" strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <span className={light ? "text-white" : "text-slate-900"}>Triply</span>
  </span>
);

export const Spinner = ({ label = "Loading…" }) => (
  <div className="flex items-center justify-center gap-2 py-16 text-slate-500" role="status" data-testid="loading-spinner">
    <Loader2 className="h-5 w-5 animate-spin text-orange-500" /> <span className="text-sm">{label}</span>
  </div>
);

export const EmptyState = ({ icon: Icon, title, text, action, testid = "empty-state" }) => (
  <div className="card grain flex flex-col items-start gap-3 p-8" data-testid={testid}>
    {Icon && (
      <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-100 text-orange-600">
        <Icon className="h-6 w-6" />
      </span>
    )}
    <h3 className="text-lg font-semibold">{title}</h3>
    {text && <p className="max-w-md text-sm text-slate-600">{text}</p>}
    {action}
  </div>
);

const STATUS = {
  planning: "bg-violet-100 text-violet-700", upcoming: "bg-orange-100 text-orange-700", in_progress: "bg-teal-100 text-teal-700",
  completed: "bg-slate-200 text-slate-700", accepted: "bg-emerald-100 text-emerald-700", invited: "bg-amber-100 text-amber-800",
  maybe: "bg-sky-100 text-sky-700", declined: "bg-rose-100 text-rose-700", revoked: "bg-slate-200 text-slate-500",
  paid: "bg-emerald-100 text-emerald-700", overdue: "bg-rose-100 text-rose-700", partial: "bg-amber-100 text-amber-800",
  needed: "bg-rose-100 text-rose-700", confirmed: "bg-emerald-100 text-emerald-700", none: "bg-slate-100 text-slate-600",
};
export const StatusPill = ({ status, label, testid }) => (
  <span className={`pill ${STATUS[status] || "bg-slate-100 text-slate-700"}`} data-testid={testid}>
    {label || String(status || "").replace("_", " ")}
  </span>
);

export const Field = ({ label, htmlFor, children, hint }) => (
  <div className="space-y-1.5">
    <Label htmlFor={htmlFor} className="text-sm font-medium text-slate-700">{label}</Label>
    {children}
    {hint && <p className="text-xs text-slate-500">{hint}</p>}
  </div>
);

export const PremiumBadge = ({ plan = "Premium" }) => (
  <span className="pill bg-gradient-to-r from-orange-100 to-amber-100 text-orange-700" data-testid="premium-badge">{plan}</span>
);

export const SectionTitle = ({ title, sub, right }) => (
  <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
    <div>
      <h2 className="text-xl font-bold sm:text-2xl">{title}</h2>
      {sub && <p className="mt-1 text-sm text-slate-600">{sub}</p>}
    </div>
    {right}
  </div>
);
